import { useLocation } from "react-router-dom";

// "/broker" is the canonical base path; "/brokers" and "/platform" remain as
// backward-compatible aliases so existing links keep working.
export const BROKER_BASE_PATHS = ["/broker", "/brokers", "/platform"];

export const getBrokerBasePath = (pathname = "") => {
  const path = String(pathname || "");
  if (path.startsWith("/platform")) return "/platform";
  if (path.startsWith("/brokers")) return "/brokers";
  return "/broker";
};

export const buildBrokerPath = (basePath, path = "") => {
  const normalizedBase = BROKER_BASE_PATHS.includes(basePath) ? basePath : "/broker";
  const normalizedPath = String(path || "");
  if (!normalizedPath || normalizedPath === "/") return normalizedBase;
  return `${normalizedBase}${normalizedPath.startsWith("/") ? normalizedPath : `/${normalizedPath}`}`;
};

export const useBrokerBasePath = () => {
  const location = useLocation();
  return getBrokerBasePath(location.pathname);
};
